import {initPillsMenuListeners} from "./components/dropDownSelector";

$(document).ready(function() {
    initPillsMenuListeners()
})